/**
* Data transfer object for my stays configuration
*/
export class MyStaysConfigurationDTO {

  id: number;

  alwaysLoginViaMyStays: boolean;

  checkRoomStatusReady: boolean;

  checkPaymentPending: boolean;

  checkAliceOnboardingNotCompleted: boolean;
  
  roomStatusReadyType: string;

  minimumCheckInTime: string;

  searchMethods: string;
  
}
